import { LoaderCircle } from 'lucide-react';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * Dev-mode auth page — reads token from URL, sets the session cookie
 * via the backend /auth/dev/login endpoint, and redirects to /.
 */
export function DevAuth(): React.ReactElement {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      void navigate('/login', { replace: true });
      return;
    }

    // Navigate to the backend dev/login endpoint which sets the cookie and redirects
    window.location.href = `/auth/dev/login?token=${encodeURIComponent(token)}`;
  }, [token, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <LoaderCircle size={24} className="animate-spin text-muted-foreground" />
    </div>
  );
}
